import './BecomeASellerComparisonSection.scss';
import { Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const BecomeASellerComparisonSection = () => {
  return (
    <div className="become-freelancer-comparison">
      <div className="comparison-container">
        {/* Header Section */}
        <div className="comparison-header-main">
          <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
            <Typography variant="h3" className="comparison-title brand" fontFamily={'goodfish'}>
              GenieGig
            </Typography>
            <Typography variant="h5" className="comparison-title others">
            &nbsp;vs Other Platforms
            </Typography>
          </div>
          <Typography variant="h6" className="comparison-subtitle">
            See why freelancers choose GenieGig
          </Typography>
        </div>

        {/* Desktop Comparison Table */}
        <div className="comparison-table desktop-table">
          <div className="comparison-header">
            <div className="feature-column">Features</div>
            <div className="platform-column geniegig-column">GenieGig</div>
            <div className="platform-column other-column">Other Platforms</div>
          </div>
          
          <div className="comparison-row">
            <div className="feature-name">Getting Started & Orders</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>Get orders Quickly</span>
            </div>
            <div className="platform-point">
              <span>Wait months for first order</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">AI-Powered Matching</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>AI-powered project matching</span>
            </div>
            <div className="platform-point">
              <span>Manual browsing and applying</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">Payment Terms</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>Talk first, offer best deal, then get paid</span>
            </div>
            <div className="platform-point">
              <span>Mention fixed amount first, get paid, then talk</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">Safety & Security</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>Original files unlocks when client accepts the work sample</span>
            </div>
            <div className="platform-point">
              <span>Original files are shared before acceptance, causes ambiguity</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">Pricing & Commission</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>Nominal commission charges (10%)</span>
            </div>
            <div className="platform-point">
              <span>High - very high commission (25-45%)</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">Transparent Pricing</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>Transparent pricing structure</span>
            </div>
            <div className="platform-point">
              <span>Hidden fees and charges</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">Competition & Market Access</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>AI geographic matching</span>
            </div>
            <div className="platform-point">
              <span>Global competition overload</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">Local Market Focus</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>Local market first</span>
            </div>
            <div className="platform-point">
              <span>Oversaturated global market</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">Support & Tools</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>24/7 AI-powered support</span>
            </div>
            <div className="platform-point">
              <span>Limited support hours</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">Support Location</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>Local call support provide quickest resolution</span>
            </div>
            <div className="platform-point">
              <span>International support with long waiting hours or days</span>
            </div>
          </div>

          <div className="comparison-row">
            <div className="feature-name">Project Management</div>
            <div className="platform-point">
              <CheckCircleIcon className="icon green-icon" />
              <span>Built-in project management tools</span>
            </div>
            <div className="platform-point">
              <span>Basic platform features only</span>
            </div>
          </div>
        </div>

        {/* Mobile Comparison Cards */}
        <div className="mobile-comparison">
          <div className="comparison-card geniegig-card">
            <div className="card-header">
              <h3>GenieGig</h3>
            </div>
            <div className="card-content">
              <div className="feature-item">
                <div className="feature-category">Getting Started & Orders</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <CheckCircleIcon className="icon green-icon" />
                    <span>Get orders Quickly</span>
                  </div>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-category">AI-Powered Matching</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <CheckCircleIcon className="icon green-icon" />
                    <span>AI-powered project matching</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Payment Terms</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <CheckCircleIcon className="icon green-icon" />
                    <span>Talk first, offer best deal, then get paid</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Safety & Security</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <CheckCircleIcon className="icon green-icon" />
                    <span>Secure escrow system</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Competition & Market Access</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <CheckCircleIcon className="icon green-icon" />
                    <span>AI geographic matching</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Local Market Focus</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <CheckCircleIcon className="icon green-icon" />
                    <span>Local market focus</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Support & Tools</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <CheckCircleIcon className="icon green-icon" />
                    <span>24/7 AI-powered support</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Project Management</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <CheckCircleIcon className="icon green-icon" />
                    <span>Built-in project management tools</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="comparison-card other-card">
            <div className="card-header">
              <h3>Other Platforms</h3>
            </div>
            <div className="card-content">
              <div className="feature-item">
                <div className="feature-category">Getting Started & Orders</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <span>Wait months for first order</span>
                  </div>
                </div>
              </div>
              
              <div className="feature-item">
                <div className="feature-category">AI-Powered Matching</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <span>Manual browsing and applying</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Payment Terms</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <span>Mention fixed amount first, get paid, then talk</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Safety & Security</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <span>Basic security measures</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Competition & Market Access</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <span>Global competition overload</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Local Market Focus</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <span>Oversaturated global market</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Support & Tools</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <span>Limited support hours</span>
                  </div>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-category">Project Management</div>
                <div className="feature-details">
                  <div className="feature-point">
                    <span>Basic platform features only</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BecomeASellerComparisonSection;
